<h1 mat-dialog-title><ng-content select="[title]"></ng-content></h1>
<mat-dialog-content class="mat-typography">
  <ng-content select="[content]"></ng-content>
  <ng-content select="[select]"></ng-content>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-content select="[actions]"></ng-content>
</mat-dialog-actions>
